module.exports = __webpack_public_path__ + "static/media/delivery.9e9b87fd.svg";